import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(VProgressCircular,{staticClass:"loader",attrs:{"width":4,"size":40,"color":_vm.brandColor,"indeterminate":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }